import React, { useState, useEffect, useRef } from 'react';
import ArrowBack from '../../assets/icons/arrow-back.svg'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import BlueLogo from '../../assets/images/blue-logo.svg'
import EditIcon from '../../assets/icons/panel/edit.svg'

import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import moment from 'jalali-moment';
import { sendRegisterOtp, registerCheckOtp, register } from "../../utils/api"
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import { useLocation } from "react-router-dom";
import useToastNotification from '../../hooks/useToastNotification';
function SignUp() {
  const toast = useRef(null);
  const [typePassword, setTypePassword] = useState('password');
  const [time, setTime] = useState(240); // Initialize with 3 minutes (180 seconds)
  const [isActive, setIsActive] = useState(false);
  const [resendBtn, setResendBtn] = useState(true);
  const [otpCode, setOtpCode] = useState('');
  const [validated, setValidated] = useState(false);
  const [checkOtpLoader, setCheckOtpLoader] = useState(false);
  // Get the location object from useLocation hook
  const location = useLocation();

  //field
  const [mobile, setMobile] = useState('');

const sentOtpRequestRef = useRef(false);

// ✅ فقط 4 رقم آخر موبایل برای GA (حریم خصوصی)
const getLast4 = (m) => (m || '').toString().slice(-4);

  const { showError, showSuccess } = useToastNotification();


  // OTP validation form submission
  const goToForm = async (event) => {
    if (event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (form.checkValidity() === true) {
        setCheckOtpLoader(true)
        if (otpCode.length == 6) {
          let payload = { mobile, otp: otpCode };
          try {
            const res = await registerCheckOtp(payload);
            if (res.data.isSuccess) {
              // ✅ ایونت استاندارد GA4 برای ثبت‌نام موفق
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'sign_up', {
      method: 'otp',
      mobile_last4: getLast4(mobile),
      debug_mode: true,
    });
  }

              //goto form
              window.location.href = `/sign-up/form?mobile=${mobile}`
              setCheckOtpLoader(false)
            } else {
              setCheckOtpLoader(false)
              showError({ text: res.data.message });
            }
          } catch (error) {
            setCheckOtpLoader(false)
            showError({ text: "خطا در ارتباط با سرور" });
          }
        } else {
          setCheckOtpLoader(false)
          showError({ text: "لطفا کد ارسالی را صحیح وارد کنید." });
        }

      }
      setValidated(true);
    }
  };



  useEffect(() => {


    // Create a new URLSearchParams object to get the query parameters
    const queryParams = new URLSearchParams(location.search);

    // Get the value of the 'mobile' query parameter
    const mobileNumber = queryParams.get("mobile");
    setMobile(mobileNumber)
    sendOtpfunction(mobileNumber)
  }, [])

  //sendOtp
  const sendOtpfunction = async (mobileNumber) => {

    try {
      setTime(240)
      setIsActive(true);
      setResendBtn(true);
      let res = await sendRegisterOtp({
        mobile: mobileNumber
      })
      if (!res.data.isSuccess) {
        let message = {
          text: res.data.message
        }
        showError(message)
      }
    } catch (error) {
      let errorMessage = error.response.data.error
      let message = {
        text: errorMessage
      }
      showError(message)
    }
  }
  const showPassword = () => {
    setTypePassword('text')
  }
  const hidePassword = () => {
    setTypePassword('password')
  }


  //setTimer
  useEffect(() => {
    let timerId;
    if (isActive && time > 0) {
      timerId = setInterval(() => {
        setTime(prevTime => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      onTimerFinish(); // Call the function when the timer reaches 0
    }
    // Cleanup interval on component unmount or when time reaches 0
    return () => clearInterval(timerId);
  }, [isActive, time]);

  //finishTimer
  const onTimerFinish = () => {
    setResendBtn(false);
  }

  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  return (
    <>
      <Toast ref={toast} />

      <div>
        <div className='body-login container'>
          <div className='login-card'>
            <button className='btn btn-primary d-flex back-btn' onClick={() => window.location.href = '/login'} > <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>
            <div className='item' style={{ marginTop: '6em' }}>
              <div className='d-flex align-items-center f-32 font-black color-primary title gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
              <h6 className='text-xl font-medium	color-primary2 mt-5'>حساب کاربری با شماره موبایل <br className='mobile'/><button type='button' style={{marginBottom: '8px'}} className='btn text-center color-primary' onClick={() => window.location.href = '/login'}><img src={EditIcon}/></button>{mobile} وجود ندارد. برای ساخت حساب جدید، کد تایید برای این شماره ارسال گردید.</h6>
              <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => goToForm(e)}>
                <Form.Group controlId="postalCode">
                  <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                  <Form.Control className='number' type="number" id="registerOtp"
                    name="registerOtp" autocomplete="one-time-code" inputMode="numeric" required value={otpCode} onChange={(e) => {
                      if (e.target.value.length <= 6) {
                        setOtpCode(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                      }
                    }}
                    onKeyDown={(e) => {

                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        goToForm(e); // Call login function
                      }
                    }} />

                </Form.Group>


                <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2 number' onClick={() => sendOtpfunction(mobile)}> {resendBtn ? formatTime(time) : 'ارسال مجدد'}</button>
                <button className='btn btn-primary mt-4 w-100 mt-1 mb-5 text-center' type='submit' style={{ width: 'auto' }}>تایید {checkOtpLoader && <Loader />}</button>
                {/* <button type='button' className='btn w-100 text-center color-primary' onClick={() => window.location.href = '/login'}>تغییر شماره موبایل</button> */}

              </Form>
            </div>
          </div>
        </div>
      </div>


    </>
  )

}
export default SignUp;
